import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Transaction } from '../../model/transaction';
import { Ptransaction } from '../../model/ptransaction';

@Injectable()
export class TransactionsState {
  private updating$ = new BehaviorSubject<boolean>(false);
  private transaction$ = new BehaviorSubject<Transaction[]>([]);
  private ptransaction$ = new BehaviorSubject<Ptransaction[]>([]);
  private prediction$ = new BehaviorSubject<any>([]);

  isUpdating$() {
    return this.updating$.asObservable();
  }

  setUpdating(isUpdating: boolean) {
    this.updating$.next(isUpdating);
  }

  getTransactions$() {
    return this.transaction$.asObservable();
  }

  getPTransactions$() {
    return this.ptransaction$.asObservable();
  }

  getPrediction$() {
    return this.prediction$.asObservable();
  }

  setTransactions$(transactions) {
    console.log('setTransaction From database', transactions);
    this.transaction$.next(transactions);
  }

  setPTransactions$(ptransactions) {
    this.ptransaction$.next(ptransactions);
  }

  setPrediction$(predictions) {
    this.prediction$.next(predictions);
  }

  addTransaction(transaction: Transaction) {
    const currentValue = this.transaction$.getValue();
    this.transaction$.next([...currentValue, transaction]);
  }

  addPTransaction(ptransaction: Ptransaction) {
    const currentValue = this.ptransaction$.getValue();
    this.ptransaction$.next([...currentValue, ptransaction]);
  }

  addTransactions(transactions: Transaction[]) {
    const currentValue = this.transaction$.getValue();
    this.transaction$.next([...currentValue, ...transactions]);
  }

  updateTransaction(updatedTransaction: Transaction) {
    const transactions = this.transaction$.getValue();
    const indexOfUpdated = transactions.findIndex(
      (transaction) => transaction.id === updatedTransaction.id
    );
    transactions[indexOfUpdated] = updatedTransaction;
    this.transaction$.next([...transactions]);
  }

  updateTransactions(updatedTransactions: Transaction[]) {
    const transactions = this.transaction$.getValue();
    updatedTransactions.forEach((updatedTransaction) => {
      const indexOfUpdated = transactions.findIndex(
        (transaction) => transaction.id === updatedTransaction.id
      );
      transactions[indexOfUpdated] = updatedTransaction;
    });
    this.transaction$.next([...transactions]);
  }

  updatePTransaction(updatedPTransaction: Ptransaction) {
    const ptransactions = this.ptransaction$.getValue();
    const indexOfUpdated = ptransactions.findIndex(
      (ptransaction) => ptransaction.id === updatedPTransaction.id
    );
    ptransactions[indexOfUpdated] = updatedPTransaction;
    this.ptransaction$.next([...ptransactions]);
  }

  updateTransactionId(
    transactionToReplace: Transaction,
    addedTransactionWithId
  ) {
    const transactions = this.transaction$.getValue();
    const updatedTransactionIndex = transactions.findIndex(
      (transaction) => transaction === transactionToReplace
    );
    transactions[updatedTransactionIndex] = addedTransactionWithId;
    this.transaction$.next([...transactions]);
  }

  updatePTransactionId(
    pTransactionToReplace: Ptransaction,
    addedPTransactionWithId
  ) {
    const ptransactions = this.ptransaction$.getValue();
    const updatedPTransactionIndex = ptransactions.findIndex(
      (ptransaction) => ptransaction === pTransactionToReplace
    );
    ptransactions[updatedPTransactionIndex] = addedPTransactionWithId;
    this.ptransaction$.next([...ptransactions]);
  }

  removeTransaction(transactionRemove: Transaction) {
    const currentValue = this.transaction$.getValue();

    this.transaction$.next(
      currentValue.filter(
        (transaction) => transaction.id !== transactionRemove.id
      )
    );
  }

  removeTransactions(transactionsToRemove: Transaction[]) {
    let currentValue = this.transaction$.getValue();
    transactionsToRemove.forEach((transactionToRemove) => {
      currentValue = currentValue.filter(
        (transaction) => transaction.id !== transactionToRemove.id
      );
    });
    this.transaction$.next(currentValue);
  }

  removePTransaction(pTransactionRemove: Ptransaction) {
    const currentValue = this.ptransaction$.getValue();

    this.ptransaction$.next(
      currentValue.filter(
        (ptransaction) => ptransaction.id !== pTransactionRemove.id
      )
    );
  }
}
